import { render, staticRenderFns } from "./RootOspitiView.vue?vue&type=template&id=1d985e13&"
import script from "./RootOspitiView.vue?vue&type=script&lang=ts&"
export * from "./RootOspitiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports